/* 產品相關接口 */

import request from '../utils/http/request.js'


export async function service_list({ venueCode, type, typeCode, time, name, pageSize, pageNumber }) {
    return await request.get('/service', {
        params: {
            venueCode, type, typeCode, time, name, pageSize, pageNumber
        }
    });
}


export async function service_add({
    venueCode = [],
    typeCode,
    sportType,
    ticketType,
    mainImage,
    name,
    timeCode,
    startTime,
    endTime,
    maxParticipants,
    points,
    organizer,
    syllabus,
    description,
    activityImages,
    activityVideos,
    facilities,
    suitableAge,
    outline,
    reminder,
    mchNo,
    genderRestrict,
    unlimitedQuota,
    femaleQuota,
    maleQuota,
    status,
    isPopular,
    isFeatured
}) {
    return await request.post('/service', {
        venueCode,
        typeCode,
        sportType,
        ticketType,
        mainImage,
        name,
        timeCode,
        startTime,
        endTime,
        maxParticipants,
        points,
        organizer,
        syllabus,
        description,
        activityImages,
        activityVideos,
        facilities,
        suitableAge,
        outline,
        reminder,
        mchNo,
        genderRestrict,
        unlimitedQuota,
        femaleQuota,
        maleQuota,
        status,
        isPopular,
        isFeatured
    });
}


export async function service_update({
    id,
    venueCode = [],
    typeCode,
    sportType,
    ticketType,
    mainImage,
    name,
    timeCode,
    startTime,
    endTime,
    maxParticipants,
    points,
    organizer,
    syllabus,
    description,
    activityImages,
    activityVideos,
    facilities,
    suitableAge,
    outline,
    reminder,
    mchNo,
    genderRestrict,
    unlimitedQuota,
    femaleQuota,
    maleQuota,
    status,
    isPopular,
    isFeatured

}) {
    return await request.put(`/service/${id}`, {
        venueCode,
        typeCode,
        sportType,
        ticketType,
        mainImage,
        name,
        timeCode,
        startTime,
        endTime,
        maxParticipants,
        points,
        organizer,
        syllabus,
        description,
        activityImages,
        activityVideos,
        facilities,
        suitableAge,
        outline,
        reminder,
        mchNo,
        genderRestrict,
        unlimitedQuota,
        femaleQuota,
        maleQuota,
        status,
        isPopular,
        isFeatured
    });
}




export async function service_detail(id) {
    return await request.get(`/service/${id}`, {});
}


export async function service_del(id) {
    return await request.delete(`/service/${id}`, {});
}